module.exports = __webpack_public_path__ + "img/1_013.5e81d213.jpg";